import logo from './../../assets/NuKenzie.svg';
import iconsHome from './../../assets/iconsHome.svg';
import './style.css';

export const HomePage = ({setIsHome}) => {

    return (

        <main className="Home">
            <div className="container">
                <div className="container-itens ">
                    <img src={logo} alt="Logo" className="logo"/>
                    <h2>Centralize o controle das suas financias</h2>
                    <p>de forma rápida e segura</p>
                    <button onClick={() => {setIsHome(false)}}>Iniciar</button>
                </div>
                <img src={iconsHome} alt="icons" className="icons"/>
            </div>
        </main>

    );

}